'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MASON_NOOP = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports.default = withFormHandler;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reduxActions = require('redux-actions');

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _formSerialize = require('form-serialize');

var _formSerialize2 = _interopRequireDefault(_formSerialize);

var _reactGoogleRecaptcha = require('react-google-recaptcha');

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _recaptcha = require('../../integrations/recaptcha');

var _recaptcha2 = _interopRequireDefault(_recaptcha);

var _api = require('../../middleware/api');

var _tree = require('../../utils/tree');

var _config = require('../../utils/config');

var _events = require('../../utils/events');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MASON_NOOP = exports.MASON_NOOP = 'MASON_NOOP';
var noop = (0, _reduxActions.createAction)(MASON_NOOP);

function _sendData(_ref) {
  var action = _ref.action,
      callbacks = _ref.callbacks,
      data = _ref.data,
      headers = _ref.headers,
      id = _ref.id,
      method = _ref.method;
  return _defineProperty({}, _api.CALL_API, {
    endpoint: action,
    headers: headers,
    verb: method || 'POST',
    lifecycleActions: [function () {
      callbacks.request();
      return noop();
    }, function (response) {
      (0, _events.emitComponentEvent)(id, 'mason.didReceiveData', response);
      callbacks.success(response);
      return noop();
    }, function (response) {
      (0, _events.emitComponentEvent)(id, 'mason.error', response);
      callbacks.error(response);
      return noop();
    }],
    data: data
  });
}

function withFormHandler(WrappedComponent) {
  var WithFormHandler = function (_Component) {
    _inherits(WithFormHandler, _Component);

    function WithFormHandler(props) {
      _classCallCheck(this, WithFormHandler);

      var _this = _possibleConstructorReturn(this, (WithFormHandler.__proto__ || Object.getPrototypeOf(WithFormHandler)).call(this, props));

      _this.createFormFromNode = _this.createFormFromNode.bind(_this);
      _this.createForms = _this.createForms.bind(_this);
      _this.resetForm = _this.resetForm.bind(_this);
      _this.setInput = _this.setInput.bind(_this);
      _this.submitForm = _this.submitForm.bind(_this);
      _this.submitRecaptcha = _this.submitRecaptcha.bind(_this);
      _this.formRefs = {};
      _this._isMounted = false;
      _this.state = {
        forms: {},
        submittingFormId: null
      };

      if (!_lodash2.default.isEmpty(props.config)) {
        _this.createForms(props.config);
      }

      return _this;
    }

    _createClass(WithFormHandler, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._isMounted = true;
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!_lodash2.default.isEqual(_lodash2.default.get(this.props, 'config.data'), _lodash2.default.get(nextProps, 'config.data'))) {
          this.createForms(nextProps.config);
        }
      }
    }, {
      key: 'setInput',
      value: function setInput(formId, _ref3) {
        var name = _ref3.name,
            value = _ref3.value;

        var form = _lodash2.default.get(this.state.forms, formId);

        if (form) {
          var idx = _lodash2.default.findIndex(form.inputs, ['name', name]);

          if (idx >= 0) {
            this.setState(function (prevState) {
              return (0, _immutabilityHelper2.default)(prevState, {
                forms: _defineProperty({}, formId, {
                  inputs: _defineProperty({}, idx, {
                    $merge: {
                      name: name,
                      value: value
                    }
                  })
                })
              });
            });
          }
        }
      }
    }, {
      key: 'createFormFromNode',
      value: function createFormFromNode(formNode, formId) {
        var inputs = _lodash2.default.map((0, _tree.findAllNodesOfTagInTree)(formNode, 'input'), function (i) {
          var _i$p = i.p,
              name = _i$p.name,
              required = _i$p.required;
          var value = i.p.value || '';
          return {
            name: name,
            required: required || false,
            value: value
          };
        });

        var formState = {
          errorMessage: '',
          hasError: false,
          inputs: inputs,
          isFetching: false,
          method: formNode.p.method,
          name: formNode.p.name,
          node: formNode,
          response: null
        };

        if (this._isMounted) {
          this.setState(function (prevState) {
            return (0, _immutabilityHelper2.default)(prevState, {
              forms: {
                $merge: _defineProperty({}, formId, formState)
              }
            });
          });
        } else {
          // can't call setState on an unmounted component
          this.state.forms[formId] = formState;
        }
      }
    }, {
      key: 'resetForm',
      value: function resetForm(id) {
        // id is configSubpath-path e.g. default-0.2
        var _props = this.props,
            config = _props.config,
            configSubpath = _props.configSubpath;
        var tree = config.data[configSubpath].tree;
        var forms = (0, _tree.findAllNodesOfTagInTree)(tree, 'form');

        var form = _lodash2.default.find(forms, ['path', _lodash2.default.last(_lodash2.default.split(id, '-'))]);

        if (form) {
          this.createFormFromNode(form, id);
        }
      }
    }, {
      key: 'createForms',
      value: function createForms(config) {
        var _this2 = this;

        var configKeys = _lodash2.default.keys(config.data);

        _lodash2.default.forEach(configKeys, function (configKey) {
          var tree = config.data[configKey].tree;
          var forms = (0, _tree.findAllNodesOfTagInTree)(tree, 'form');

          _lodash2.default.forEach(forms, function (form) {
            return _this2.createFormFromNode(form, configKey + '-' + form.path);
          });
        });
      }
    }, {
      key: 'submitForm',
      value: function submitForm(id) {
        var _this3 = this;

        var formRef = this.formRefs[id];

        if (formRef) {
          var creds = (0, _formSerialize2.default)(formRef, {
            hash: true
          });
          var inputs = this.state.forms[id].inputs;

          var requiredInputs = _lodash2.default.filter(inputs, 'required');

          var requiredFieldNames = _lodash2.default.map(requiredInputs, 'name');

          var requiredFields = _lodash2.default.pick(creds, requiredFieldNames);

          var incompleteFields = _lodash2.default.difference(requiredFieldNames, _lodash2.default.keys(creds));

          var emptyRequiredFields = _lodash2.default.filter(requiredFields, function (field) {
            return _lodash2.default.isEmpty(field);
          });

          var errorFields = _lodash2.default.concat(incompleteFields, emptyRequiredFields);

          if (_lodash2.default.isEmpty(errorFields)) {
            // add componentId as query param to form action
            var data = (0, _formSerialize2.default)(formRef, {
              hash: true
            });
            var _state$forms$id = this.state.forms[id],
                method = _state$forms$id.method,
                name = _state$forms$id.name;
            var action = formRef.action;

            if (_lodash2.default.toUpper(formRef.method) === 'GET') {
              data.componentId = this.props.config.componentId;
            } else {
              if (!formRef.action.includes('?')) {
                action += '?';
              } else {
                action += '&';
              }

              action += 'componentId=' + this.props.config.componentId;
            }

            var ownData = {
              action: action,
              data: data,
              headers: {
                'Content-Type': formRef.getAttribute('enctype') || 'application/json'
              }
            }; // Expose action and headers in case they want to modify them in willSendData

            var e = (0, _events.emitComponentEvent)(this.props.config.componentId, 'mason.willSendData', ownData);

            if (e !== null && e.defaultPrevented) {
              return;
            }

            this.props.willSendData(ownData, name, formRef).then(function (d) {
              if (d === false) {
                return;
              }

              _this3.props.sendData({
                action: d.action,
                callbacks: {
                  request: function request() {
                    return _this3.setState(function (prevState) {
                      return (0, _immutabilityHelper2.default)(prevState, {
                        forms: _defineProperty({}, id, {
                          $merge: {
                            hasError: false,
                            isFetching: true,
                            response: null
                          }
                        })
                      });
                    });
                  },
                  success: function success(response) {
                    var _$get = _lodash2.default.get(_this3.state.forms, id),
                        node = _$get.node;

                    if (_lodash2.default.has(node.p, '_events.success')) {
                      var dsEvents = [];

                      _lodash2.default.forEach(node.p._events.success, function (successAction) {
                        if (successAction.type === 'form') {
                          if (successAction.action === 'reset') {
                            _this3.resetForm(id);
                          }
                        } else if (successAction.type === 'page') {
                          _this3.props.setConfigSubpath(successAction.id);
                        } else if (successAction.type === 'datasource') {
                          dsEvents.push({
                            action: successAction.action,
                            data: response,
                            datasourceId: successAction.id,
                            path: successAction.path
                          });
                        }
                      });

                      if (dsEvents.length) {
                        _this3.props.updateDatasources(dsEvents);
                      }
                    } else if (_lodash2.default.has(node.p, '_success')) {
                      _lodash2.default.forEach(node.p._success, function (successAction) {
                        // backwards compatability - builder now does objects
                        var parts = _lodash2.default.split(successAction, ':');

                        switch (_lodash2.default.first(parts)) {
                          case 'form':
                            // form related actions
                            if (_lodash2.default.last(parts) === 'reset') {
                              _this3.resetForm(id);
                            }

                            break;

                          case 'mason':
                            // config subpath change
                            _this3.props.setConfigSubpath(_lodash2.default.last(parts));

                            break;

                          case 'datasource':
                            // datasource action
                            _this3.props.updateDatasource(_lodash2.default.last(parts), response, parts[1]);

                            break;

                          default:
                            break;
                        }
                      });
                    }

                    _this3.setState(function (prevState) {
                      return (0, _immutabilityHelper2.default)(prevState, {
                        forms: _defineProperty({}, id, {
                          $merge: {
                            hasError: false,
                            isFetching: false,
                            response: response
                          }
                        })
                      });
                    });

                    return _this3.props.didReceiveData(response, name);
                  },
                  error: function error(response) {
                    var errorMessage = 'Whoops! An unexpected error occurred.';

                    if (_lodash2.default.isString(response)) {
                      errorMessage = response;
                    } else if (_lodash2.default.has(response, 'error') && _lodash2.default.isString(response.error)) {
                      errorMessage = response.error;
                    }

                    _this3.setState(function (prevState) {
                      return (0, _immutabilityHelper2.default)(prevState, {
                        forms: _defineProperty({}, id, {
                          $merge: {
                            errorMessage: errorMessage,
                            hasError: true,
                            isFetching: false,
                            response: response
                          }
                        })
                      });
                    });

                    _this3.props.onError(response);
                  }
                },
                data: d.data,
                headers: d.headers,
                id: id,
                method: _lodash2.default.toUpper(method)
              });
            }).catch(function (error) {
              // willSendData threw an error or returned a rejected promise, try to show an error
              _this3.setState(function (prevState) {
                return (0, _immutabilityHelper2.default)(prevState, {
                  forms: _defineProperty({}, id, {
                    $merge: {
                      errorMessage: _lodash2.default.isString(error) ? error : 'Form validation failed.',
                      hasError: true,
                      isFetching: false
                    }
                  })
                });
              });
            });
          }
        }
      }
    }, {
      key: 'submitRecaptcha',
      value: function submitRecaptcha(response) {
        var _this4 = this;

        this.recaptcha.reset();

        _recaptcha2.default.verify(response, this.props.config.componentId).then(function () {
          _this4.submitForm(_this4.state.submittingFormId);
        }).catch(function () {
          _this4.setState(function (prevState) {
            return (0, _immutabilityHelper2.default)(prevState, {
              forms: _defineProperty({}, _this4.state.submittingFormId, {
                $merge: {
                  errorMessage: 'Unable to verify reCAPTCH. Please submit again.',
                  hasError: true,
                  isFetching: false
                }
              })
            });
          });
        }).finally(function () {
          _this4.setState({
            submittingFormId: null
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this5 = this; // we keep a ref to each form, handle submission, and listen for changes to inputs


        var forms = this.state.forms;
        var _props2 = this.props,
            config = _props2.config,
            recaptchaSiteKey = _props2.recaptchaSiteKey;

        var nextConfig = _extends({}, config);

        if (!_lodash2.default.isEmpty(config)) {
          var configKeys = _lodash2.default.keys(config.data);

          _lodash2.default.forEach(configKeys, function (configKey) {
            var tree = _extends({}, config.data[configKey].tree);

            var formNodes = (0, _tree.findAllNodesOfTagInTree)(tree, 'form');

            _lodash2.default.forEach(formNodes, function (form) {
              var formId = configKey + '-' + form.path;
              tree = (0, _tree.setPropOnNodeInTree)(tree, form.path, 'ref', function (ref) {
                _this5.formRefs[formId] = ref;
              });
              var inputs = (0, _tree.findAllNodesOfTagInTree)(form, 'input', [], form.path);

              _lodash2.default.forEach(inputs, function (input) {
                tree = (0, _tree.setPropOnNodeInTree)(tree, input.path, 'onChange', function (e) {
                  if (input.name) {
                    var handlerName = _lodash2.default.camelCase('on ' + input.name + ' change');

                    if (_lodash2.default.has(_this5.props.eventHandlers, handlerName) && _lodash2.default.isFunction(_this5.props.eventHandlers[handlerName])) {
                      _this5.props.eventHandlers[handlerName](e);

                      if (e.defaultPrevented) {
                        return;
                      }
                    }
                  } // we store the values of all inputs and update them on change


                  _this5.setInput(formId, {
                    name: input.p.name,
                    value: e.target.value
                  });
                }); // forms may not be created yet, so make it ''
                // to avoid react uncontrolled->controlled warning

                tree = (0, _tree.setPropOnNodeInTree)(tree, input.path, 'value', '');

                var f = _lodash2.default.get(forms, formId);

                if (f) {
                  var i = _lodash2.default.find(f.inputs, function (i) {
                    return i.name === input.p.name;
                  });

                  if (i) {
                    // if we have the input in the store (we should) then set its rendered value
                    tree = (0, _tree.setPropOnNodeInTree)(tree, input.path, 'value', i.value || '');
                  }
                }
              });

              var selectsAndTextAreas = _lodash2.default.concat((0, _tree.findAllNodesOfTagInTree)(tree, 'select', [], form.path), (0, _tree.findAllNodesOfTagInTree)(tree, 'textarea', [], form.path));

              _lodash2.default.forEach(selectsAndTextAreas, function (input) {
                if (input.name) {
                  var handlerName = _lodash2.default.camelCase('on ' + input.name + ' change');

                  if (_lodash2.default.has(_this5.props.eventHandlers, handlerName) && _lodash2.default.isFunction(_this5.props.eventHandlers[handlerName])) {
                    tree = (0, _tree.setPropOnNodeInTree)(tree, input.path, 'onChange', _this5.props.eventHandlers[handlerName]);
                  }
                }
              });

              var buttons = (0, _tree.findAllNodesOfTagInTree)(form, 'button', [], form.path);

              _lodash2.default.forEach(buttons, function (button) {
                if (button.p._function === 'submitForm') {
                  // attach a click handler to any buttons that submit the form
                  tree = (0, _tree.setPropOnNodeInTree)(tree, button.path, 'onClick', function (e) {
                    e.preventDefault();

                    if (_this5.state.submittingFormId === formId) {
                      return; // it's already submitted
                    }

                    if (!_lodash2.default.isEmpty(recaptchaSiteKey)) {
                      // if they've got recaptcha enabled we submit it first
                      // because it's async we put the form id in state and submit it after
                      _this5.setState({
                        submittingFormId: formId
                      }, function () {
                        _this5.recaptcha.execute();
                      });
                    } else {
                      _this5.submitForm(formId);
                    }
                  });

                  var _$get2 = _lodash2.default.get(forms, formId, {}),
                      isFetching = _$get2.isFetching;

                  if (isFetching) {
                    // if the form is fetching, disable the button and show a loading state
                    tree = (0, _tree.setTextOnNodeInTree)(tree, button.path, 'Loading...');
                    tree = (0, _tree.setPropOnNodeInTree)(tree, button.path, 'disabled', 'disabled');
                  }
                }
              });

              var f = _lodash2.default.get(forms, formId);

              if (f) {
                var error = {
                  tag: 'p',
                  p: {
                    style: {
                      color: '#EF452F',
                      display: _lodash2.default.isEmpty(f.errorMessage) ? 'none' : 'block',
                      marginBottom: 0,
                      marginTop: 25
                    }
                  },
                  t: f.errorMessage
                };
                tree = (0, _tree.unshiftChildOnNodeInTree)(tree, form.path, error);
              }
            }); // put the updated tree in the config so we can pass it on as a prop


            nextConfig = (0, _immutabilityHelper2.default)(nextConfig, {
              data: _defineProperty({}, configKey, {
                tree: {
                  $set: tree
                }
              })
            });
          });
        }

        return (0, _reactHyperscript2.default)(_react.Fragment, [(0, _reactHyperscript2.default)(WrappedComponent, _extends({}, this.props, {
          config: nextConfig
        })), this.props.recaptchaSiteKey && (0, _reactHyperscript2.default)(_reactGoogleRecaptcha2.default, {
          badge: 'bottomleft',
          ref: function ref(_ref4) {
            _this5.recaptcha = _ref4;
          },
          size: 'invisible',
          sitekey: this.props.recaptchaSiteKey,
          onChange: this.submitRecaptcha
        })]);
      }
    }]);

    return WithFormHandler;
  }(_react.Component);

  WithFormHandler.propTypes = {
    config: _propTypes2.default.shape({
      componentId: _propTypes2.default.string,
      data: _propTypes2.default.object,
      id: _propTypes2.default.string
    }),
    configSubpath: _propTypes2.default.string.isRequired,
    didReceiveData: _propTypes2.default.func,
    eventHandlers: _propTypes2.default.object,
    // eslint-disable-line
    onError: _propTypes2.default.func,
    recaptchaSiteKey: _propTypes2.default.string,
    sendData: _propTypes2.default.func.isRequired,
    setConfigSubpath: _propTypes2.default.func.isRequired,
    updateDatasource: _propTypes2.default.func.isRequired,
    updateDatasources: _propTypes2.default.func.isRequired,
    willSendData: _propTypes2.default.func
  };
  WithFormHandler.defaultProps = {
    config: {},
    didReceiveData: _lodash2.default.identity,
    eventHandlers: {},
    onError: _lodash2.default.identity,
    recaptchaSiteKey: '',
    willSendData: _lodash2.default.identity
  };

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
      didReceiveData: function didReceiveData(ownResponse, name) {
        var response = ownResponse;

        var didReceiveData = _lodash2.default.get(ownProps, 'didReceiveData', _lodash2.default.get(state.mason.callbacks, ownProps.id + '.didReceiveData'));

        if (_lodash2.default.isFunction(didReceiveData)) {
          response = didReceiveData(response, name, ownProps.id);
        }

        if (_lodash2.default.isFunction(state.mason.callbacks.didReceiveData)) {
          response = state.mason.callbacks.didReceiveData(response, name, ownProps.id);
        }

        return response;
      },
      recaptchaSiteKey: (0, _config.getValueForIntegration)(_lodash2.default.get(ownProps, 'config'), 'recaptcha', 'siteKey'),
      willSendData: function willSendData(ownData, name, ref) {
        var data = ownData;

        var willSendData = _lodash2.default.get(ownProps, 'willSendData', _lodash2.default.get(state.mason.callbacks, ownProps.id + '.willSendData', _lodash2.default.identity));

        if (!_lodash2.default.isFunction(willSendData)) {
          return data;
        }

        return Promise.resolve(willSendData(ownData, name, ownProps.id, ref)).then(function (d) {
          if (d === false) {
            return false;
          }

          data = d;

          if (_lodash2.default.isFunction(state.mason.callbacks.willSendData)) {
            return Promise.resolve(state.mason.callbacks.willSendData(data, name, ownProps.id, ref));
          }

          return data;
        });
      }
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      sendData: function sendData(_ref5) {
        var action = _ref5.action,
            callbacks = _ref5.callbacks,
            data = _ref5.data,
            headers = _ref5.headers,
            id = _ref5.id,
            method = _ref5.method;
        dispatch(_sendData({
          action: action,
          callbacks: callbacks,
          data: data,
          headers: headers,
          id: id,
          method: method
        }));
      }
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WithFormHandler);
}